import NotificationPreviewList from './NotificationPreviewList';

export default NotificationPreviewList;
